export default __webpack_public_path__ + "f05ce0290dc5cd2d3d60d2955102693f.png";